import React from 'react';
import { MapPin, Phone, Instagram } from 'lucide-react';
import Image from 'next/image';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-5 gap-8 text-center md:text-right pr-4">
        <div className='pr-5 flex items-center  justify-center'>
          <Image src="/pwa-512x512.svg" alt='logo' width={100} height={100} />
          <p className='m-4'>بامادر همه روزه از ساعت 9 صبح تا 11 شب در کنار شماست</p>
        </div>
        <div className='pr-5'>
          <h3 className="text-lg  font-bold mb-4">دسترسی سریع</h3>
          <ul className="space-y-2">
            <li>تماس با ما</li>
            <li>درباره ما</li>
            <li>سوالات متداول</li>
            <li>مقالات</li>
          </ul>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-4">در تماس باشیم</h3>
          <p>ایران – خوزستان- دزفول – خیابان حضرت شهید بهشتی بین فجر و معزی روبروی بیمه سینا</p>
          <div className="flex items-center justify-center md:justify-start space-x-2 space-x-reverse mt-2">
            <MapPin className="w-5 h-5" />
            <span>آدرس</span>
          </div>
          <div className="flex items-center justify-center md:justify-start space-x-2 space-x-reverse">
            <Phone className="w-5 h-5" />
            <span>061-3833</span>
          </div>
          <div className="flex items-center justify-center md:justify-start space-x-2 space-x-reverse">
            <Phone className="w-5 h-5" />
            <span>061-42544444</span>
          </div>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-4">شبکه های اجتماعی</h3>
          <div className="flex items-center justify-center md:justify-start space-x-2 space-x-reverse">
            <Instagram className="w-5 h-5" />
            <span>@madar-hyper</span>
          </div>
        </div>
        <div className='flex items-center justify-center' >
          <Image src='/enamad.png' alt='enamad'width={100} height={100} />
          <Image src='/rezi.webp' alt='enamad'width={100} height={100} />
           
        </div>
      </div>
      <div className="text-center text-sm mt-8 border-t border-gray-700 pt-4">
        تمام حقوق این وب سایت متعلق به مجموعه مادر می‌باشد.
      </div>
    </footer>
  );
};

export default Footer;
